import { RootState } from 'src/store';

import { IPaymentForm, IPaymentRoutingData } from './types';

export const selectPaymentRoutingData = (state: RootState): Partial<IPaymentRoutingData> => state.paymentRouting.routing.data;
export const selectPaymentRoutingLoading = (state: RootState): boolean => state.paymentRouting.routing.isLoading;
export const selectPaymentRoutingLoaded = (state: RootState): boolean => state.paymentRouting.routing.isLoaded;
export const selectPaymentRouteData = (state: RootState): Partial<IPaymentForm> => state.paymentRouting.route.data;
export const selectPaymentRouteLoading = (state: RootState): boolean => state.paymentRouting.route.isLoading;
export const selectPaymentRouteLoaded = (state: RootState): boolean => state.paymentRouting.route.isLoaded;
